import { Alert, Form, InputNumber, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { monoFontFamily } from './vinExtractionStyles';
import ThinkingLevelField from './ThinkingLevelField';

const SettingsFields = ({ settings }) => {
    const { t } = useTranslation('vinExtraction');
    const { confidence, batchCarLimit } = settings.bounds;
    const required = [{ required: true, message: t('edit.required') }];

    return (
        <>
            <Form.Item
                name="confidenceThreshold"
                label={t('edit.threshold')}
                rules={required}
                extra={t('edit.thresholdHelp', {
                    min: confidence.min.toFixed(2),
                    max: confidence.max.toFixed(2),
                    step: confidence.step,
                })}
            >
                <InputNumber
                    min={confidence.min}
                    max={confidence.max}
                    step={confidence.step}
                    precision={2}
                    style={{ width: '100%' }}
                />
            </Form.Item>
            <Form.Item
                name="batchCarLimit"
                label={t('edit.batchSize')}
                rules={required}
                extra={t('edit.batchSizeHelp', { min: batchCarLimit.min, max: batchCarLimit.max })}
            >
                <InputNumber
                    min={batchCarLimit.min}
                    max={batchCarLimit.max}
                    step={1}
                    precision={0}
                    style={{ width: '100%' }}
                />
            </Form.Item>
            <Form.Item name="model" label={t('edit.model')} rules={required}>
                <Select
                    options={settings.allowedModels.map(model => ({
                        value: model,
                        label: <span style={{ fontFamily: monoFontFamily }}>{model}</span>,
                    }))}
                />
            </Form.Item>
            <ThinkingLevelField settings={settings} />
            {settings.modelAllowed === false && (
                <Alert type="warning" showIcon message={t('edit.modelNotAllowed', { model: settings.model ?? '—' })} />
            )}
        </>
    );
};

export default SettingsFields;
